import React from 'react';
import { I18n } from 'aws-amplify/utils';
import UUID from "../../../Utils/UUID";
import './NoDataPlaceholder.css';

const factoryUUID = new UUID();

/**
 * Affiche un message lorsqu'aucune donnée n'est disponible.
 * @param {object} props
 * @param {boolean} props.shown
 * @param {string} [props.className]
 */
export default function NoDataPlaceholder( props ) {
	const id = factoryUUID.generate();

	let noDataPlaceholderCss = "no-data-placeholder";

	if( props.shown ) {
		noDataPlaceholderCss += " shown";
	} 
	
	if( props.className ) {
		noDataPlaceholderCss += " " + props.className ;
	}
	
	return (
		<React.Fragment>
			<div key={id} className={noDataPlaceholderCss}>
				{I18n.get("No available data")}
			</div>
		</React.Fragment>
	);
}
